// Title: on-window-resize.ts
//
// Author: Jacco van der Post <vanderpost@redkiwi.nl>
//
// Date: 16-03-2022
//

import { ShowMediaQueryDev } from "./show-media-query-dev";

/**
 * Do stuf when the viewport gets resized
 */
export class OnWindowResize {
    constructor() {
        window.onresize = OnWindowResize.doStuf;
    }

    /**
     * Show media query on resizing of viewport
     *
     * @private
     *
     * @return void
     */
    private static doStuf(): void {
        new ShowMediaQueryDev();
    }
}
